import styled from 'styled-components'

const Container = styled.div``

const CreationSourceEditorStickersPanel = () => {
    return <Container>Stickers</Container>
}

export default CreationSourceEditorStickersPanel
